import React from "react";
import { InteractionType } from "@azure/msal-browser";
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import { loginRequest } from "auth/auth-config";
import { msalInstance } from "auth/msalInstance";

interface AuthProviderProps {
    children: React.ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    return (
        <MsalProvider instance={msalInstance}>
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
                {children}
            </MsalAuthenticationTemplate>
        </MsalProvider>
    );
};

export default AuthProvider;
